// Check if string is an e-mail address
function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

// Fix Links to e-mail addresses without mailto: prefix
$(document).ready(function() {
    $('a[href*="@"]:not([href^=http]):not([href^=mailto])').each(function() {
        var href = $(this).attr('href');
        if(isEmail(href)) {
            $(this).attr('href', 'mailto:' + href).attr("target", "_blank");
        }
    });
});